import React from "react";
import { useNavigate } from "react-router-dom";
import { useDataContext } from "../../context/DataContext";
import "../../styles/landing-page.css";

function LandingPage() {
  const navigate = useNavigate();

  // Use DataContext for client-specific data (default or lavagna)
  const { graficiDataJson, dataLoaded } = useDataContext();

  // Use graficiDataJson as the dataJson for navigation
  const dataJson = graficiDataJson || {};

  return (
    <div className="landing">
      <button
        className="landing-button"
        onClick={() => navigate("/analisi", { state: { dataJson } })}
      >
        Analisi Singola
      </button>
      <button
        className="landing-button"
        onClick={() => navigate("/confronto", { state: { dataJson } })}
      >
        Confronto Scenari
      </button>
    </div>
  );
}

export default LandingPage;
